import { useState, useEffect } from 'react';
import DEFAULT_ITEMS from './data';

const STORAGE_KEY = 'lavanderia_items';

export default function useItems() {
  const [items, setItems] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : DEFAULT_ITEMS.map(i => ({ ...i }));
    } catch {
      return DEFAULT_ITEMS.map(i => ({ ...i }));
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const updateItem = (id, locacao, lavanderia) => {
    setItems(prev =>
      prev.map(item =>
        item.id === id ? { ...item, locacao, lavanderia } : item
      )
    );
  };

  const resetItems = () => {
    setItems(DEFAULT_ITEMS.map(i => ({ ...i })));
    localStorage.removeItem(STORAGE_KEY);
  };

  const getItem = (id) => items.find(i => i.id === id);

  const getPrice = (id, mode) => {
    const item = getItem(id);
    if (!item) return 0;
    if (mode === 'locacao') return item.locacao;
    if (mode === 'lavanderia') return item.lavanderia;
    return item.locacao + item.lavanderia;
  };

  return { items, updateItem, resetItems, getItem, getPrice };
}
